import {ArrowRight, CheckCircle2} from 'lucide-react'
import { Link } from 'react-router-dom'

function InscricaoConfirmada() {
  let nome = ''
  try {
    nome = sessionStorage.getItem('capacitacao_nome') || ''
  } catch {
    // ignore
  }

  return (
    <div className="min-h-screen bg-[#F8F4EF] flex items-center justify-center px-4 py-12">
      <div className="max-w-xl w-full bg-white rounded-3xl p-8 sm:p-12 border border-[#EDE0D4] shadow-sm text-center">
        <div className="w-16 h-16 rounded-full bg-[#D8F3DC] flex items-center justify-center mx-auto mb-5">
          <CheckCircle2 className="text-[#2D6A4F]" size={36} />
        </div>
        <h1 className="font-cormorant text-2xl sm:text-4xl font-semibold text-[#2C2C2A] mb-3">
          Inscrição confirmada!
        </h1>
        {nome && (
          <p className="text-[#52B788] font-medium mb-2">{nome.split(' ')[0]} ✨</p>
        )}
        <p className="text-[#5F5E5A] text-sm sm:text-base leading-relaxed mb-8 max-w-md mx-auto">
          O próximo passo é acessar o curso <strong>Uma Gota de Equilíbrio</strong> e começar sua primeira aula.
        </p>
        <p className="text-[#5F5E5A] text-sm sm:text-base leading-relaxed mb-8 max-w-md mx-auto">
          Você tem 7 aulas curtinhas com quiz e certificado incluído.
        </p>
        <Link
          to="/curso"
          className="inline-flex items-center gap-2 bg-[#2D6A4F] text-white text-base font-medium px-7 py-3.5 rounded-full hover:bg-[#1f4f3a] transition-all shadow-md hover:shadow-lg"
        >
          Acessar o curso
          <ArrowRight size={18} />
        </Link>
        <div className="mt-7 pt-7 border-t border-[#EDE0D4] text-xs sm:text-sm text-[#5F5E5A]">
          Seleção Descubra seus Óleos · contato@descubraseusoleos.com.br
        </div>
      </div>
    </div>
  )
}

export default InscricaoConfirmada
